function ToolTip({ message }) {
  return (
    <div
      className="position-absolute d-flex flex-column"
      style={{
        top: "50%",
        right: "120%",
        transform: "translateY(-50%)",
        zIndex: 99,
      }}
    >
      <div
        style={{
          position: "relative",
          backgroundColor: "#333",
          color: "#fff",
          padding: "8px 12px",
          borderRadius: "6px",
          fontSize: "0.8rem",
          minWidth: "150px",
          maxWidth: "300px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
          wordWrap: "break-word",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "-6px",
            transform: "translateY(-50%)",
            width: 0,
            height: 0,
            borderTop: "6px solid transparent",
            borderBottom: "6px solid transparent",
            borderLeft: "6px solid #333",
          }}
        />
        {message}
      </div>
    </div>
  );
}

export default ToolTip;
